import { render, staticRenderFns } from "./three-D-collection.vue?vue&type=template&id=0ce2baa9&scoped=true"
import script from "./three-D-collection.vue?vue&type=script&lang=js"
export * from "./three-D-collection.vue?vue&type=script&lang=js"
import style0 from "./three-D-collection.vue?vue&type=style&index=0&id=0ce2baa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce2baa9",
  null
  
)

export default component.exports